import React from "react";
import pluralize from "pluralize";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { MuiThemeProvider } from "@material-ui/core/styles";
import DoneRoundedIcon from "@material-ui/icons/DoneRounded";
import { TableSelectProps } from "./TableSelect.types";
import { Input, SvgIcon } from "@material-ui/core";
import {
  MenuProps,
  useStyles,
  Title,
  SelectContainer,
  MuiTheme,
} from "./TableSelect.styles";

export const TableSelect: React.FC<TableSelectProps> = ({
  options,
  onFilterChanged,
  id,
  title,
  filter,
}) => {
  const classes = useStyles();
  const [selections, setSelections] = React.useState<string[]>(options);
  const [anySelected, setAnySelected] = React.useState<boolean>(true);

  const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
    let value = event.target.value;

    if (value[value.length - 1] === "any") {
      if (selections.length === options.length) {
        value = [];
        setSelections(value);
        setAnySelected(false);
      } else {
        setSelections(options);
        setAnySelected(true);
      }
    } else {
      if (value.length === options.length) {
        setSelections(value);
        setAnySelected(true);
      } else {
        setSelections(value);
        setAnySelected(false);
      }
    }

    onFilterChanged(id, value);
  };

  return (
    <SelectContainer>
      <Title>{title}</Title>
      <FormControl className={classes.formControl}>
        <MuiThemeProvider theme={MuiTheme}>
          <Select
            multiple
            value={selections}
            onChange={handleChange}
            input={
              <Input
                classes={{
                  formControl: classes.inputFormControl,
                  root: classes.inputRoot,
                  input: classes.input,
                }}
              />
            }
            MenuProps={MenuProps}
            renderValue={(selections: any) =>
              selections.length === options.length
                ? "Any " + pluralize.singular(title)
                : selections.join(", ")
            }
            onClose={() => {
              if (selections.length === 0) {
                setSelections(options);
                setAnySelected(true);
                onFilterChanged(id, ["any"]);
              }
            }}
            IconComponent={props => (
              <SvgIcon {...props}>
                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
              </SvgIcon>
            )}
          >
            <MenuItem
              selected
              value={"any"}
              classes={{
                root: anySelected ? classes.selectedAny : classes.rootAny,
              }}
            >
              {"Any " + pluralize.singular(title)}
            </MenuItem>
            {options.map((option: any, idx: any) => (
              <MenuItem
                selected
                key={idx}
                value={option}
                classes={{
                  root: classes.root,
                  selected: classes.selected,
                }}
              >
                <DoneRoundedIcon
                  style={{
                    fontSize: "16px",
                    marginLeft: "-10px",
                    marginRight: "5px",
                  }}
                />
                {filter.enum ? filter.enumOptions[option] : option}
              </MenuItem>
            ))}
          </Select>
        </MuiThemeProvider>
      </FormControl>
    </SelectContainer>
  );
};
